import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import DateRangeForm from "./components/DateRangeForm";
import { connect } from "react-redux";
import {
  CommercialDateRangeError,
  CommercialDateRangeInput,
} from "modules/user_management/commercial_user/user/state/actionType";
import {
  fetchCommercialNewRegister,
  resetCommercialUserDetails,
} from "modules/user_management/commercial_user/user/state/action";
import FilteredTable from "./FilteredTable";
import formatDateForBackend from "utils/helpers/formateDateForBackend";
import { ApiError } from "components";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const FetchDcddUser: React.FC<Props> = ({
  onFetchCommercialUsers,
  fetchCommercialUsers,
  onResetData,
}) => {
  const [formData, setFormData] = useState<CommercialDateRangeInput>({
    from_date: "",
    to_date: "",
  });
  const [error, setError] = useState<CommercialDateRangeError>({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const newFormData = { ...prevData, [name]: value };

      let newErrors: CommercialDateRangeError = { ...error };

      if (newFormData.from_date && newFormData.to_date) {
        if (newFormData.from_date > newFormData.to_date) {
          newErrors.from_date = "From date should be earlier than To date";
          newErrors.to_date = "To date should be later than From date";
        } else {
          newErrors.from_date = "";
          newErrors.to_date = "";
        }
      } else {
        newErrors.from_date = "";
        newErrors.to_date = "";
      }

      setError(newErrors);

      return newFormData;
    });
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    const errors: CommercialDateRangeError = {};

    if (!formData.from_date) {
      errors.from_date = "From date is required";
    }
    if (!formData.to_date) {
      errors.to_date = "To date is required";
    }

    if (
      formData.from_date &&
      formData.to_date &&
      formData.from_date > formData.to_date
    ) {
      errors.from_date = "From date should be earlier than To date";
      errors.to_date = "To date should be later than From date";
    }

    setError(errors);
    setSubmitted(true);
    setLoading(true);
    const fromDate = formatDateForBackend(formData.from_date);
    const toDate = formatDateForBackend(formData.to_date);
    try {
      await onFetchCommercialUsers(fromDate, toDate);
    } catch (err) {
      console.error("Failed to fetch user:", err);
    } finally {
      setLoading(false); // always runs, even if fetch throws
    }
  };
  const commercialUsers = fetchCommercialUsers.newRegisterUsers;
  useEffect(() => {
    onResetData();
    if (!fetchCommercialUsers.isLoading && submitted) {
      if (fetchCommercialUsers.error) {
        setApiError(fetchCommercialUsers.error);
      } else {
        setApiError(null);
      }
    }
  }, [fetchCommercialUsers.isLoading, fetchCommercialUsers.error, submitted]);
  return (
    <>
      <div className="mx-8 mt-8">
        <h2 className="text-2xl font-medium mb-2">
          Search the commercial users by date range
        </h2>
        <DateRangeForm
          formData={formData}
          error={error}
          loading={loading}
          handleChange={handleChange}
          handleSubmit={handleSave}
        />
        <div className="border mt-8" />
      </div>
      {apiError && <ApiError>{apiError}</ApiError>}
      {fetchCommercialUsers.newRegisterUsers &&
      fetchCommercialUsers.newRegisterUsers.length > 0 ? (
        <FilteredTable commercialUserData={commercialUsers} />
      ) : (
        <div className="h-[20vh] flex justify-center items-center text-xl font-medium text-primary-400">
          No data to show
        </div>
      )}
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchCommercialUsers: state.commercialUser.commercialUserState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onFetchCommercialUsers: (from_date: string, to_date: string) =>
    dispatch(fetchCommercialNewRegister(from_date, to_date)),
  onResetData: () => dispatch(resetCommercialUserDetails()),
});
export default connect(mapStateToProps, mapDispatchToProps)(FetchDcddUser);
